import { RadioGroup as HeadlessRadioGroup } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

const Option = ({ children, label, description, className, ...props }) => (
  <HeadlessRadioGroup.Option
    {...props}
    className={twMerge('grow basis-0 rounded-lg', className)}
  >
    <div
      className={twMerge(
        'py-3 px-5 rounded-lg bg-background border border-input',
        'transition-colors duration-500 ease-in-out',
        'hover:cursor-pointer hover:bg-accent',
        'h-full',
        'ui-checked:bg-accent ui-checked:border-ring',
        'ui-disabled:cursor-not-allowed'
      )}
    >
      <h4 className='font-semibold inline-block py-1'>{label}</h4>

      <p className='text-sm'>
        {description}
      </p>
    </div>
  </HeadlessRadioGroup.Option>
)

export default Option
